import { createContext } from "react";
const notecontext=createContext();
export default notecontext;